let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j2Tdl")).then(() => parcelRequire('al5TY'));